import { useChatFeature } from '../chatsRegistry';
import { useConversationInviteInfo } from '../model/conversation/selectors';

const INVITE_DISABLED = {
   isReceiver: false,
   canChat: true,
   isFeatureGated: false,
   remainingMessages: 0,
};

export const useChatRequest = activeChatJid => {
   const isInviteEnabled = useChatFeature('invite_new_member');
   const inviteInfo = useConversationInviteInfo(activeChatJid);

   if (isInviteEnabled === false) return INVITE_DISABLED;

   return inviteInfo;
};
